import {accountRegister, forgotPassword, getWebConfig, sendEmailCode} from "../../api";
import {
    detectPlatform,
    getUrlParams,
    hideUrlParam,
    timeFormat,
    validateEmail,
    validatePassword
} from "../../util/commonUtil";
import {errorToast, successToast, tipToast} from "../../util/toastUtils";
import {sendCustomEvent} from "../../util/slog";
import langJson from '../../excelDeal/lang.json'
let webConfig = {
    "download_url": {
        "mac_arm": "",
        "mac_intel": "",
        "windows": ""
    },
    "current_version_win": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "current_version_mac": {
        "version_name": "",
        "version_value": 0,
        "update_time": 0
    },
    "invite_required": 0,
    "get_invite_url": "",
    "qywx": {
        "kefu": ""
    }
}


const lang = langJson[__LANG]


const registerVerificationCodeText = $('#sendRegisterVerificationCode').text();
let countdown = 60;
let timer = null;
let isCounting = false;
//发送注册验证码
const sendRegisterCode = async () => {
    const email = $('#registerEmailInput').val()
    if (!validateEmail(email)) {
        return errorToast(lang.account_error_tip)
    }

    // 如果正在倒计时，则阻止点击
    if (isCounting) {
        return false;
    }

    // 开始倒计时
    isCounting = true;
    let $btn = $('#sendRegisterVerificationCode');

    // 禁用按钮（可选，视样式需要）
    $btn.prop('disabled', true);

    // 初始化倒计时文字
    $btn.text(countdown + 's');

    // 设置倒计时定时器
    timer = setInterval(function() {
        countdown--;

        if (countdown <= 0) {
            // 倒计时结束
            clearInterval(timer);
            $btn.text(registerVerificationCodeText);
            $btn.prop('disabled', false);
            countdown = 60;
            isCounting = false;
        } else {
            // 更新倒计时显示
            $btn.text(countdown + 's');
        }
    }, 1000);

    const res = await sendEmailCode({email: email,type: 'register'})
    if (res.code === 1) {
        sendCustomEvent('smscode',`suc register email-${email}`)
        successToast(res.msg)
    } else {
        clearInterval(timer);
        $btn.text(registerVerificationCodeText);
        $btn.prop('disabled', false);
        countdown = 60;
        isCounting = false;
        sendCustomEvent('smscode',`fail register email-${email} msg-${res.msg}`)
        errorToast(res.msg)
    }
}
//发送忘记密码验证码
const sendForgetCode = async () => {
    const email = $('#forgetEmailInput').val()
    if (!validateEmail(email)) {
        return errorToast(lang.account_error_tip)
    }

    // 如果正在倒计时，则阻止点击
    if (isCounting) {
        return false;
    }

    // 开始倒计时
    isCounting = true;
    let $btn = $('#sendForgetVerificationCode');

    // 禁用按钮（可选，视样式需要）
    $btn.prop('disabled', true);

    // 初始化倒计时文字
    $btn.text(countdown + 's');

    // 设置倒计时定时器
    timer = setInterval(function() {
        countdown--;

        if (countdown <= 0) {
            // 倒计时结束
            clearInterval(timer);
            $btn.text(registerVerificationCodeText);
            $btn.prop('disabled', false);
            countdown = 60;
            isCounting = false;
        } else {
            // 更新倒计时显示
            $btn.text(countdown + 's');
        }
    }, 1000);

    const res = await sendEmailCode({email: email,type: 'forgot'})
    if (res.code === 1) {
        sendCustomEvent('smscode',`suc reset email-${email}`)
        successToast(res.msg)
    } else {
        clearInterval(timer);
        $btn.text(registerVerificationCodeText);
        $btn.prop('disabled', false);
        countdown = 60;
        isCounting = false;
        sendCustomEvent('smscode',`fail reset email-${email} msg-${res.msg}`)
        errorToast(res.msg)
    }
}
//注册
const registerAccount = async () => {
  if ($('#registerLoading').css('display') !== 'none') return;
  const registerForm = {
      email: $('#registerEmailInput').val(),
      code: $('#registerVerificationCodeInput').val(),
      password: $('#registerPasswordInput').val(),
      confirmPassword: $('#registerConfirmPasswordInput').val(),
      invite_code: $('#registerInvitationCodeInput').val(),
  }
  if (!validateEmail(registerForm.email)) {
      return errorToast(lang.account_error_tip)
  }
  if (!registerForm.code || registerForm.code.trim() === '') {
      return errorToast(lang.verification_input_default)
  }
  if (!registerForm.password || registerForm.password.trim() === '') {
     return errorToast(lang.password_input_default)
  }
  if (!validatePassword(registerForm.password)) {
      return errorToast(lang.password_error_tip_two)
  }
  if (registerForm.password.length < 6 || registerForm.password.length > 20 ) {
      return errorToast(lang.password_error_tip)
  }

  if (registerForm.password !== registerForm.confirmPassword) {
      return errorToast(lang.password_error_tip_three)
  }

  if (webConfig.invite_required && !registerForm.invite_code) {
      return errorToast(lang.invite_code_input_default)
  }

  $('#registerLoading').show()
   const params = {
      account: registerForm.email,
      password: registerForm.password,
      code: registerForm.code,
      invite_code: registerForm.invite_code === '' ? undefined : registerForm.invite_code
   }
  const res = await accountRegister(params)
  if (res.code === 1) {
      localStorage.setItem('praide_user',JSON.stringify(res.data))
      sendCustomEvent('reg_complete', `suc email-${params.email}`)
      successToast(res.msg)
      closeRegisterDialog()
      const platform = detectPlatform()
      if (platform.includes('win') || platform.includes('mac')) {
          openLaunchDialog()
      }
  } else {
      sendCustomEvent('reg_complete', `fail email-${params.email} msg-${res.msg}`)
      errorToast(res.msg)
  }
  $('#registerLoading').hide()


}
//忘记密码
const forgetAccount = async () => {
    if ($('#forgetLoading').css('display') !== 'none') return;
    const forgetForm = {
        email: $('#forgetEmailInput').val(),
        code: $('#forgetVerificationCodeInput').val(),
        password: $('#forgetPasswordInput').val(),
        confirmPassword: $('#forgetConfirmPasswordInput').val(),
    }
    if (!validateEmail(forgetForm.email)) {
        return errorToast(lang.account_error_tip)
    }
    if (!forgetForm.code || forgetForm.code.trim() === '') {
        return errorToast(lang.verification_input_default)
    }
    if (!forgetForm.password || forgetForm.password.trim() === '') {
        return errorToast(lang.new_password_placeholder)
    }
    if (!validatePassword(forgetForm.password)) {
        return errorToast(lang.password_error_tip_two)
    }
    if (forgetForm.password.length < 6 || forgetForm.password.length > 20 ) {
        return errorToast(lang.password_error_tip)
    }

    if (forgetForm.password !== forgetForm.confirmPassword) {
        return errorToast(lang.password_error_tip_three)
    }


    $('#forgetLoading').show()
    const params = {
        account: forgetForm.email,
        password: forgetForm.password,
        code: forgetForm.code,
    }
    const res = await forgotPassword(params)
    if (res.code === 1) {
        sendCustomEvent('reset_password', `suc email-${params.email}`)
        successToast(res.msg)
        closeForgetDialog()
    } else {
        sendCustomEvent('reset_password', `fail email-${params.email} msg-${res.msg}`)
        errorToast(res.msg)
    }
    $('#forgetLoading').hide()


}
const copy = (text) => {
    // 兼容旧浏览器的后备方案
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '0';
    textArea.style.top = '0';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand('copy');
    successToast(lang.copy_success)
    document.body.removeChild(textArea);
}

const activateScriptsByCategory = (category) => {
    const scriptsToActivate = document.querySelectorAll(`script[type="text/plain"][data-cookieconsent="${category}"]`);
    scriptsToActivate.forEach(oldScript => {
        const newScript = document.createElement('script');
        for (const attr of oldScript.attributes) {
            if (attr.name !== 'type' && attr.name !== 'data-cookieconsent') {
                newScript.setAttribute(attr.name, attr.value);
            }
        }
        newScript.type = 'text/javascript';
        if (oldScript.innerHTML) {
            newScript.innerHTML = oldScript.innerHTML;
        }
        if (oldScript.parentNode) {
            oldScript.parentNode.replaceChild(newScript, oldScript);
        }
    });
}

const initCookie = () => {
    const localCookie = localStorage.getItem('accept_cookie')
    if (!localCookie) {
        return $('#cookieDialog').show()
    }
    let localCookieList = JSON.parse(localCookie)
    try {
        localCookieList.forEach(it => {
            activateScriptsByCategory(it)
        })
    } catch (e) {
        localStorage.removeItem('accept_cookie')
        $('#cookieDialog').show()
    }
}

const closeCookieDialog = () => {
    $('#cookieDialog').hide()
}

const rejectCookie = () => {
    localStorage.setItem('accept_cookie',JSON.stringify([]))
    initCookie()
    closeCookieDialog()
}

const acceptCookie = () => {
    localStorage.setItem('accept_cookie',JSON.stringify(['analytics']))
    initCookie()
    closeCookieDialog()
}



const download = (type,site) => {
    const platform = detectPlatform()
    const downloadType = getUrlParams('type')
    if (platform.includes('win') || platform.includes('mac')) {
        if (type === 'win') {
            console.log('win')
            if (!webConfig.download_url.windows) return  tipToast(lang.unpack_tip)
            window.location.href = webConfig.download_url.windows
            sendCustomEvent('download_click',`pack-win site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && (!downloadType || downloadType.includes('win'))) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

        if (type === 'mac_m') {
            console.log('mac_m')
            if (!webConfig.download_url.mac_arm)  return  tipToast(lang.unpack_tip)
            window.location.href = webConfig.download_url.mac_arm
            sendCustomEvent('download_click',`pack-mac_m site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

        if (type === 'mac_intel') {
            console.log('mac_intel')
            if (!webConfig.download_url.mac_intel)  return  tipToast(lang.unpack_tip)
            window.location.href = webConfig.download_url.mac_intel
            sendCustomEvent('download_click',`pack-mac_intel site-${site}`)
            //下载界面无需跳
            if (window.location.href.includes('/download') && downloadType.includes('mac')) return
            setTimeout(() => {
                window.location.href = __PAGE_DOMAIN__ + `download?type=${type}`
            },500)
            return
        }

    } else {
        $('#contactUsDialog').css('display','flex')
    }
}
const openRegisterDialog = () => {
    closeForgetDialog()
    closeForgetDialog()
    $('#accountDialog').css('display','flex')
}

const closeRegisterDialog = () => {
    $('#registerEmailInput').val('')
    $('#registerVerificationCodeInput').val('')
    $('#registerPasswordInput').val('')
    $('#registerConfirmPasswordInput').val('')
    $('#registerInvitationCodeInput').val('')
    clearInterval(timer)
    let $btn = $('#sendRegisterVerificationCode');
    $btn.text(registerVerificationCodeText);
    $btn.prop('disabled', false);
    countdown = 60;
    isCounting = false;
    $('#accountDialog').hide()
}

const openForgetDialog = () => {
    closeRegisterDialog()
    closeForgetDialog()
    $('#forgetDialog').css('display','flex')
}

const closeForgetDialog = () => {
    $('#forgetEmailInput').val('')
    $('#forgetVerificationCodeInput').val('')
    $('#forgetPasswordInput').val('')
    $('#forgetConfirmPasswordInput').val('')
    clearInterval(timer)
    let $btn = $('#sendForgetVerificationCode');
    $btn.text(registerVerificationCodeText);
    $btn.prop('disabled', false);
    countdown = 60;
    isCounting = false;
    $('#forgetDialog').hide()
}


const initPage = () => {
    const scheme = getUrlParams('scheme')
    if (scheme && scheme === 'register') {
        openRegisterDialog()

    } else if (scheme && scheme === 'forget') {
        openForgetDialog()
    }
    hideUrlParam('scheme')

    const scode = getUrlParams('scode')
    if (scode) {
        localStorage.setItem('scode',scode)
        $("#registerInvitationCodeInput").val(scode)
    }
}
//打开启动客户端弹窗
const openLaunchDialog = () => {
    const userString = localStorage.getItem('praide_user')
    let appUrl = 'praide://signup'
    if (userString) {
        const user = JSON.parse(userString)
        const urlToken = user.user_info.token
        const uuid = user.user_info.uuid
        appUrl += `?token=${encodeURIComponent(urlToken)}&uuid=${encodeURIComponent(uuid)}`
    }
    console.log(appUrl)

    window.location.href = appUrl
    $('#launchDialog').css('display','flex')
}
//关闭启动客户端弹窗
const closeLaunchDialog = () => {
    $('#launchDialog').hide()
}
$(function () {
    initPage()
    initCookie()
    //发送访问日志
    sendCustomEvent('view',window.location.href)
    let platform = detectPlatform()

    getWebConfig().then(res => {
        if (res.code === 1) {
            webConfig = res.data
            if (webConfig.get_invite_url) {
                $('#inviteCodeUrl').attr('href',webConfig.get_invite_url)
            }

            $('#winVersion').text(`${lang.version}:V${webConfig.current_version_win.version_name !== '' ? webConfig.current_version_win.version_name : '0.0.0'} | ${lang.update_time}:${timeFormat(new Date(webConfig.current_version_win.update_time * 1000),'yyyy-MM-dd')}`)
            $('#winVersionBottom').text(`${lang.version}:V${webConfig.current_version_win.version_name !== '' ? webConfig.current_version_win.version_name : '0.0.0'} | ${lang.update_time}:${timeFormat(new Date(webConfig.current_version_win.update_time * 1000),'yyyy-MM-dd')}`)
            $('#macVersion').text(`${lang.version}:V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | ${lang.update_time}:${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000),'yyyy-MM-dd')}`)
            $('#macVersionBottom').text(`${lang.version}:V${webConfig.current_version_mac.version_name !== '' ? webConfig.current_version_mac.version_name : '0.0.0'} | ${lang.update_time}:${timeFormat(new Date(webConfig.current_version_mac.update_time * 1000),'yyyy-MM-dd')}`)
            $('.page_one_info').css('opacity','1')
        }
    })

    //下载完成界面显示win/mac安装教程
    const downloadType = getUrlParams('type')
    if (downloadType.includes('mac')) {
        $('#winList').hide()
        $('#macList').css('display','grid')
    } else {
        $('#winList').css('display','grid')
        $('#macList').hide()
    }

    //下载完成界面的重试按钮
    $('#reDownload').on('click',() => {
        const type = getUrlParams('type')
        if (type === 'mac_m') {
            download('mac_m','download-page')
        } else if (type === 'mac_intel') {
            download('mac_intel','download-page')
        } else {
            download('win','download-page')
        }
    })

    $('#topDownloadWin').on('click',() => {
        download('win','banner')
    })
    $('#topDownloadMacM').on('click',() => {
        download('mac_m','banner')
    })
    $('#topDownloadMacIntel').on('click',() => {
        download('mac_intel','banner')
    })

    $('#downloadWin').on('click',() => {
        download('win','home')
    })
    $('#downloadWinBottom').on('click',() => {
        download('win','home')
    })

    $('#downloadMacM').on('click',() => {
        download('mac_m','home')
    })
    $('#downloadMacMBottom').on('click',() => {
        download('mac_m','home')
    })

    $('#downloadMacIntel').on('click',() => {
        download('mac_intel','home')
    })

    $('#downloadMacIntelBottom').on('click',() => {
        download('mac_intel','home')
    })


    $('#contactUsClose').on('click',function () {
        $('#contactUsDialog').hide()
    })

    //邮箱复制
    $('#emailCopy').on('click',function () {
        copy(lang.contact_email)
    })



    // 点击播放图片
    $('#playOneVideo').click(function() {
        var $video = $('#pageOneVideo');
        var videoSrc = __ASSETS_URL + `assets/video/pr_video.mp4?v=${Date.now().toString()}`; // 替换为实际视频链接

        // 隐藏播放按钮图片
        $(this).hide();

        // 设置视频源并播放
        $video.attr('src', videoSrc);
        // 显示控制器
        $video.prop('controls', true);
        $video[0].play();
    });

    // 视频播放结束事件
    $('#pageOneVideo').on('ended', function() {
        // 显示播放按钮图片
        $('#playOneVideo').show();

        // 重置视频（可选）
        $(this).currentTime = 0
        $(this).prop('controls', false);
    });

    //首页第二屏

    $('.page_two_tab_item').on('click',function (e) {
        $('.page_two_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_two_tab_item_active')
            $('.page_two_tab_content_img')[index].classList.remove('page_two_tab_content_img_active')
        });
        $('.page_two_tab_item')[$(this).index()].classList.add('page_two_tab_item_active')
        $('.page_two_tab_content_img')[$(this).index()].classList.add('page_two_tab_content_img_active')
    })

    //首页第三屏

    $('.page_three_tab_item').on('click',function (e) {
        $('.page_three_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_three_tab_item_active')
            $('.page_three_tab_content_img')[index].classList.remove('page_three_tab_content_img_active')
        });
        $('.page_three_tab_item')[$(this).index()].classList.add('page_three_tab_item_active')
        $('.page_three_tab_content_img')[$(this).index()].classList.add('page_three_tab_content_img_active')
    })

    //首页第五屏
    $('.page_five_content_item').on('click',function (e) {
        $('.page_five_content_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_five_content_item_active')
            $('.img_page_five')[index].classList.remove('page_five_tab_content_img_active')
        });
        $('.page_five_content_item')[$(this).index()].classList.add('page_five_content_item_active')
        $('.img_page_five')[$(this).index()].classList.add('page_five_tab_content_img_active')
    })
    //首页第七屏
    $('.page_seven_tab_item').on('click',function (e) {
        $('.page_seven_tab_item').each(function(index, element) {
            // 对每个元素执行操作
            element.classList.remove('page_seven_tab_item_active')
            $('.page_seven_tab_content_item')[index].classList.remove('page_seven_tab_content_img_active')
        });
        $('.page_seven_tab_item')[$(this).index()].classList.add('page_seven_tab_item_active')
        $('.page_seven_tab_content_item')[$(this).index()].classList.add('page_seven_tab_content_img_active')
    })


    //打开注册弹窗
    $('#registerBtn').on('click',() => {
        openRegisterDialog()
    })
    //关闭注册弹窗
    $('#accountDialogClose').on('click',() => {
        closeRegisterDialog()
    })
    //获取注册验证码
     $('#sendRegisterVerificationCode').on('click',sendRegisterCode)
    //点击注册
    $('#registerSubmit').on('click',registerAccount)
    //注册密码睁开点击
    $('#openRegisterPasswordInput').on('click',() => {
        $('#registerPasswordInput').attr('type','text')
        $('#openRegisterPasswordInput')[0].classList.add('account_password_img_none')
        $('#closeRegisterPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //注册密码闭眼点击
    $('#closeRegisterPasswordInput').on('click',() => {
        $('#registerPasswordInput').attr('type','password')
        $('#closeRegisterPasswordInput')[0].classList.add('account_password_img_none')
        $('#openRegisterPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //注册确认密码睁开点击
    $('#openRegisterConfirmPasswordInput').on('click',() => {
        $('#registerConfirmPasswordInput').attr('type','text')
        $('#openRegisterConfirmPasswordInput')[0].classList.add('account_password_img_none')
        $('#closeRegisterConfirmPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //注册确认密码闭眼点击
    $('#closeRegisterConfirmPasswordInput').on('click',() => {
        $('#registerConfirmPasswordInput').attr('type','password')
        $('#closeRegisterConfirmPasswordInput')[0].classList.add('account_password_img_none')
        $('#openRegisterConfirmPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //关闭打开客户端弹窗
    $('#launchDialogClose').on('click',closeLaunchDialog)
    //打开忘记密码弹窗
    $('#forgetBtn').on('click',openForgetDialog)
    //打开注册弹窗
    $('#registerLinkBtn').on('click',openRegisterDialog)
    //关闭忘记密码弹窗
    $('#forgetDialogClose').on('click',closeForgetDialog)
    //忘记密码睁开点击
    $('#openForgetPasswordInput').on('click',() => {
        $('#forgetPasswordInput').attr('type','text')
        $('#openForgetPasswordInput')[0].classList.add('account_password_img_none')
        $('#closeForgetPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //忘记密码闭眼点击
    $('#closeForgetPasswordInput').on('click',() => {
        $('#forgetPasswordInput').attr('type','password')
        $('#closeForgetPasswordInput')[0].classList.add('account_password_img_none')
        $('#openForgetPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //忘记确认密码睁开点击
    $('#openForgetConfirmPasswordInput').on('click',() => {
        $('#forgetConfirmPasswordInput').attr('type','text')
        $('#openForgetConfirmPasswordInput')[0].classList.add('account_password_img_none')
        $('#closeForgetConfirmPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //忘记确认密码闭眼点击
    $('#closeForgetConfirmPasswordInput').on('click',() => {
        $('#forgetConfirmPasswordInput').attr('type','password')
        $('#closeForgetConfirmPasswordInput')[0].classList.add('account_password_img_none')
        $('#openForgetConfirmPasswordInput')[0].classList.remove('account_password_img_none')
    })
    //发送忘记密码验证码
    $('#sendForgetVerificationCode').on('click',sendForgetCode)
    //忘记密码提交
    $('#forgetSubmit').on('click',forgetAccount)
    //接受cookie
    $('#acceptCookieBtn').on('click',acceptCookie)
    //拒绝cookie
    $('#rejectCookieBtn').on('click',rejectCookie)
})
